// extracted by mini-css-extract-plugin
export var projects = "Projects-module--projects--dD0PV";
export var cards_wrap = "Projects-module--cards_wrap--J25HH";